// fieldHelpers.js

/**
 * Returns the style object for a field based on whether it is highlighted.
 * @param {string} fieldName - The name of the current field.
 * @param {string} highlightedField - The name of the field to highlight.
 * @returns {object} - Style object to apply to the field.
 */
export const getFieldStyle = (fieldName, highlightedField) => {
  if (fieldName === highlightedField) {
    return {
      border: "3px solid #1876d2",
      borderRadius: "4px",
      padding: "4px",
    };
  }
  return {};
};

/**
 * Scrolls to the field if a valid reference is found.
 * @param {string} highlightedField - The name of the field to scroll to.
 * @param {object} fieldRefs - An object mapping field names to React refs.
 */
export const scrollToField = (highlightedField, fieldRefs) => {
  if (highlightedField) {
    if (
      highlightedField === "individualsAffected" ||
      highlightedField === "equipmentList" ||
      highlightedField === "materialList"
    ) {
      fieldRefs[highlightedField]?.current?.scrollToField();
    } else {
      const fieldRef = fieldRefs[highlightedField]?.current;

      if (fieldRef) {
        fieldRef.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        console.log(`No ref found for field: ${highlightedField}`);
      }
    }
  }
};
